var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',{staticClass:"asp-root",class:_vm.tenantClass},[_c('router-view'),_c('vue-snotify'),_c('n-confirm-dialog',{ref:"confirm-dialog"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }